export default "assets/images/icons/facebook-9caedbc2.svg";